import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { ApiClient } from '@sfs-projects/sfs-fc-api-sdk';
import env from "@/utils/env";

const perPage = env.VUE_APP_PER_PAGE;

interface CreditorResponse {
    Paginate: {
        currentPage: number;
        perPage: number;
        totalRow: number;
    };
    creditorList: Array<any>;
}

@Module({ namespaced: true })
class CreditorsModule extends VuexModule {
    public creditorData: Array<any> = [];
    public lastKey: any;

    @Mutation
    public setCreditorData(list: Array<any>): void {
        this.creditorData = list;
    }

    @Mutation
    public setCreditorLastKey(lastKey: any): void {
        this.lastKey = lastKey;
    }

    @Action
    public updateCreditors(params: any): void {
        this.context.commit('setCreditorData', params)
    }

    @Action
    public updateLastKey(params: any): void {
        this.context.commit('setCreditorLastKey', params)
    }

    @Mutation
    public addCreditorList(list: Array<any>): void {
        list.forEach(item => {
            const index = this.creditorData.findIndex(x => x.Creditor == item.Creditor)
            if (index === -1) {
                this.creditorData.push(item);
            }
        })
    }

    @Action
    public async getItemPerPage(params: any): Promise<any> {
        params.page = params.page ?? 1; //set page default = 1 if page not send
        return new Promise((resolve, reject) => {
            const totalpage = this.creditorData.length / perPage;
            if (params.page >= totalpage && this.lastKey) {
                //@TODO : query more if not last key
                params.filter.LastKey = this.lastKey;
                ApiClient.post('creditors/search', params.filter).then((response: any) => {
                    const debtorList = response.data;
                    //keep data AND lastkey in state
                    this.context.commit('addCreditorList', debtorList)
                    this.context.commit('setCreditorLastKey', response.LastKey)
                    const result = {
                        Paginate: {
                            currentPage: params.page,
                            perPage: perPage,
                            totalRow: this.creditorData.length
                        },
                        creditorList: this.creditorData.slice(perPage * (params.page - 1), perPage * (params.page - 1) + perPage)
                    }
                    resolve(result);
                }, error => {
                    reject(error);
                });
            } else {
                const result = {
                    creditorList: this.creditorData.slice(perPage * (params.page - 1), perPage * (params.page - 1) + perPage)
                }
                resolve(result);
            }
        })
    }

    @Action
    public async retrieveCreditors(params: any): Promise<CreditorResponse> {
        return new Promise((resolve, reject) => {
            //@TODO: check if filter data already have in state
            // if state have data then return that data
            ApiClient.post('creditors/search', params).then((response: any) => {
                const creditorList = response.data;
                //keep data AND lastkey in state
                this.context.dispatch('updateCreditors', creditorList)
                this.context.commit('setCreditorLastKey', response.LastKey)
                const result = {
                    Paginate: {
                        currentPage: 1,
                        perPage: perPage,
                        totalRow: this.creditorData.length
                    },
                    creditorList: creditorList.slice(0, perPage) // get first perpage item
                }
                resolve(result);
            }, error => {
                reject(error);
            });
        })
    }

    @Action
    public async retrieveCreditorById(creditorId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.creditorData.length > 0) {
                const creditor = this.creditorData.find((creditor) => {
                    return creditor.Creditor === creditorId;
                });
                this.context.dispatch('updateCreditors', creditor);
                resolve(creditor);
            }
            const urlApi = 'creditors/' + creditorId + '?AdmNr=99000';
            ApiClient.get(urlApi).then((value: any) => {
                if (value.success) {
                    const result = value.data[0];
                    this.context.dispatch('updateCreditors', result);
                    resolve(result);
                }
                reject(value);
            }, error => {
                reject(error);
            });
        })
    }

    @Action
    public async addCreditor(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            const urlApi = 'creditors';
            ApiClient.post(urlApi, data).then((value: any) => {
                if (value.success) {
                    const result = value.data[0];
                    this.context.dispatch('updateCreditors', result);
                    resolve(result);
                }
                resolve({ Error: value.data });
            }, (error) => {
                resolve({ Error: error.response.data });
            });
        })
    }

    @Action
    public async editCreditor(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            const urlApi = 'creditors/' + data.Creditor;
            delete data.Creditor;
            ApiClient.patch(urlApi, data).then((value: any) => {
                if (value.success) {
                    const result = value.data[0];
                    this.context.dispatch('updateCreditors', result);
                    resolve(result);
                }
                resolve({ Error: value.data });
            }, error => {
                resolve({ Error: error.response.data });
            });
        })
    }
}
export default CreditorsModule